/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Component } from '@angular/core';

/**
 * Generated class for the EntryTimelineComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'entry-timeline-component',
  templateUrl: 'entry-timeline-component.html'
})
export class EntryTimelineComponent {

  text: string;

  constructor() {
    console.log('Hello EntryTimelineComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/entry-timeline-component/entry-timeline-component.ts